import { render, staticRenderFns } from "./ManufacturingLogbookMakerForm.vue?vue&type=template&id=22080a5c&scoped=true"
import script from "./ManufacturingLogbookMakerForm.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbookMakerForm.vue?vue&type=script&lang=js"
import style0 from "./ManufacturingLogbookMakerForm.vue?vue&type=style&index=0&id=22080a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22080a5c",
  null
  
)

export default component.exports